import styleInject from './../../../externals/style-inject/dist/style-inject.es.js';

var css_248z = ".Bancontact-module_bancontactTabsWrapper__jPvfL {\n  flex-direction: column;\n}\n@media (min-width: 544px) {\n  .Bancontact-module_bancontactTabsWrapper__jPvfL {\n    flex-direction: row;\n  }\n}";
var styles = {"bancontactTabsWrapper":"Bancontact-module_bancontactTabsWrapper__jPvfL"};
styleInject(css_248z);

export { styles as default };
//# sourceMappingURL=Bancontact.module.scss.js.map
